import TagManager from "@sooro-io/react-gtm-module";
import { useEffect } from "react";

const initializedContainers = new Set<string>();

export function useGoogleTagManager(gtmId: string): void {
  useEffect(() => {
    if (import.meta.env.MODE === "test") {
      return;
    }

    if (initializedContainers.has(gtmId)) {
      return;
    }

    TagManager.initialize({ gtmId });
    initializedContainers.add(gtmId);
  }, [gtmId]);
}
